module.exports = __webpack_public_path__ + "img/type8.633cacf1.png";